<template>
  <v-dialog
    retain-focus
    :value="edit"
    v-on:click:outside="goToShow"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Edit Product</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="goToShow"
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form width="100%" ref="editForm" v-model="createValid">
          <v-text-field
            :rules="validationRules.name"
            v-model="editFields.name"
            label="Product Name*"
            :error-messages="inputErrorMessages('name')"
            name="name"
            tabindex="0"
          />
          <v-text-field
            :rules="validationRules.price"
            v-model="editFields.price"
            label="Product Price*"
            :error-messages="inputErrorMessages('price')"
            name="price"
            tabindex="1"
          />
          <v-textarea
            :rules="validationRules.description"
            v-model="editFields.description"
            label="Product Description*"
            :error-messages="inputErrorMessages('description')"
            counter="255"
            name="description"
            tabindex="2"
          ></v-textarea>
          <v-select
            v-model="editFields.supplier_id"
            :items="suppliers"
            item-text="company_name"
            item-value="id"
            label="Supplier"
            :error-messages="inputErrorMessages('supplier_id')"
            name="supplier_id"
            tabindex="3"
          ></v-select>
          <!--<v-text-field
            v-if="!!editFields.supplier_id"
            v-model="editFields.supplier_code"
            label="Supplier Product Code"
            :error-messages="inputErrorMessages('supplier_code')"
            name="supplier_code"
            tabindex="4"
          ></v-text-field>-->
          <v-select
            v-model="editFields.product_type_id"
            :items="productTypes"
            item-text="name"
            item-value="id"
            label="Product Type*"
            :error-messages="inputErrorMessages('product_type_id')"
            name="product_type"
            tabindex="5"
          ></v-select>

          <v-file-input
            chips
            multiple
            label="Upload sketches/illustration"
            v-model="editFields.files"
            name="files[]"
            tabindex="6"
            :error-messages="inputErrorMessages('files')"
          ></v-file-input>
          <div
            :key="index"
            v-for="(file, index) in editFields.current_files"
            @click="removeFile(index)"
          >
            <v-badge bordered color="error" icon="mdi-close" overlap>
              <v-img :src="'/attachement/' + file.path" max-height="50px" max-width="50px" />
            </v-badge>
          </div>
          <v-select
            v-model="editFields.karat"
            :items="karats"
            item-text="name"
            item-value="name"
            label="Karat"
            :error-messages="inputErrorMessages('karat')"
            name="karat"
            tabindex="7"
          ></v-select>

          <v-text-field
            :rules="validationRules.item_weight"
            v-model="editFields.item_weight"
            label="Item Weight*"
            :error-messages="inputErrorMessages('item_weight')"
            name="item_weight"
            tabindex="8"
          />

          <v-text-field
            :rules="validationRules.rate_gram"
            v-model="editFields.rate_gram"
            label="Rate/Gram*"
            :error-messages="inputErrorMessages('rate_gram')"
            name="rate_gram"
            tabindex="9"
          />

          <v-text-field
            :rules="validationRules.measurement"
            v-model="editFields.measurement"
            label="Measurement*"
            :error-messages="inputErrorMessages('measurement')"
            name="measurement"
            tabindex="10"
          />

          <v-select
            v-model="editFields.gold_classification"
            :items="goldClassifications"
            item-text="name"
            item-value="name"
            label="Classification of Gold"
            :error-messages="inputErrorMessages('kagold_classificationrat')"
            name="gold_classification"
            tabindex="11"
          ></v-select>

          <v-text-field
            v-if="editFields.gold_classification == 'Others'"
            :rules="validationRules.other_gold_classification"
            v-model="editFields.other_gold_classification"
            :error-messages="inputErrorMessages('other_gold_classification')"
            name="other_gold_classification"
            tabindex="11"
          />

          <v-text-field
            :rules="validationRules.no_of_diamond"
            v-model="editFields.no_of_diamond"
            label="No. of Diamonds*"
            :error-messages="inputErrorMessages('no_of_diamond')"
            name="no_of_diamond"
            tabindex="12"
          />

          <v-list subheader>
            <v-subheader class="d-block" style="padding: 0; height: auto;"
              >Specification
              <span
                class="red--text d-block"
                v-bind:key="index"
                v-for="(message, index) in inputErrorMessages('meta')"
                >{{ message }}</span
              >
            </v-subheader>
            <v-list-item
              style="padding: 0;"
              v-for="(spec, index) in editFields.meta"
              v-bind:key="index"
            >
              <v-list-item-content>
                <v-text-field dense :label="spec.specName" v-model="spec.value"></v-text-field>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon color="primary" @click="removeSpec(index)">close</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item style="padding: 0;">
              <v-list-item-content>
                <v-text-field
                  dense
                  label="New Spec name"
                  v-model="editFields.newSpec.name"
                  :error-messages="addSpecError"
                ></v-text-field>
                <v-text-field
                  dense
                  label="New Spec value"
                  v-model="editFields.newSpec.value"
                ></v-text-field>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon
                  color="primary"
                  @click="addSpec(editFields.newSpec.name, editFields.newSpec.value)"
                  >mdi-plus</v-icon
                >
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="goToShow">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="saveProduct">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      addSpecError: undefined,
      continousCreation: false,
      createValid: true,
      validationRules: {
        name: [
          v => !!v || this.rem('Product name'),
          v => v.length <= 255 || 'Product name should not be greater than 255'
        ],
        description: [
          v => !!v || this.rem('Description'),
          v => v.length <= 255 || 'Description should not be greater than 255'
        ],
        price: [
          v => !!v || this.rem('Price'),
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Price should be a number',
          v => v > 0 || 'Price should be greater than 0'
        ],
        supplier_id: [v => !!v || this.rem('Supplier')],
        product_type_id: [v => !!v || this.rem('Product Type')]
        //supplier_code: [v => (v.supplier_id != '' && v != '') || 'Supplier Code is required']
      },
      errorMessages: {},
      editFields: {
        price: 0,
        files: undefined,
        name: '',
        description: '',
        supplier_id: undefined,
        current_files: [],
        //supplier_code: '',
        product_type_id: '',
        clasification: 0,
        karat: '',
        item_weight: '',
        rate_gram: '',
        measurement: '',
        gold_classification: '',
        other_gold_classification: '',
        no_of_diamond: '',
        meta: [],
        newSpec: {
          name: '',
          value: ''
        }
      }
    };
  },
  computed: {
    ...mapState({
      suppliers: state => state.Supplier.plainsuppliers,
      productTypes: state => state.ProductType.plainproductTypes,
      //classifications: state => state.Classification.classifications,
      karats: state => state.Karat.karats,
      goldClassifications: state => state.GoldClassification.goldClassifications,
      product(state) {
        if (typeof state.Product.product.data == 'undefined') {
          return {
            price: 0,
            name: '',
            description: '',
            supplier_id: undefined,
            //supplier_code: '',
            product_type_id: '',
            clasification: 0,
            karat: '',
            item_weight: '',
            rate_gram: '',
            measurement: '',
            gold_classification: '',
            other_gold_classification: '',
            no_of_diamond: '',
            meta: [],
            newSpec: {
              name: '',
              value: ''
            }
          };
        }
        return state.Product.product.data;
      }
    })
  },
  watch: {
    product(value) {
      console.log(value.files);
      // files = value.files;
      // const current_files = value.files;
      console.log(value);
      this.editFields.name = value.name;
      this.editFields.price = value.price;
      this.editFields.description = value.description;
      this.editFields.supplier_id = value.supplier_id;
      this.editFields.current_files = value.files;
      //this.editFields.supplier_code = value.supplier_code;
      this.editFields.product_type_id = value.product_type_id;
      this.editFields.karat = value.karat;
      this.editFields.item_weight = value.item_weight;
      this.editFields.rate_gram = value.rate_gram;
      this.editFields.measurement = value.measurement;
      this.editFields.gold_classification = value.gold_classification;
      this.editFields.other_gold_classification = value.other_gold_classification;
      this.editFields.no_of_diamond = value.no_of_diamond;
      this.editFields.meta = JSON.parse(value.meta);
    }
  },
  mounted() {
    this['Product/getProduct']({ id: this.$route.params.id });
    this['Supplier/fetchSuppliers']({ dontPaginate: false });
    this['ProductType/fetchProductTypes']({ dontPaginate: false });
    //this['Classification/fetchClassification']({ dontPaginate: false });
    //this['Karat/fetchKarats']({ dontPaginate: false });
    //this['GoldClassification/fetchGoldClassifications']({ dontPaginate: false });
  },
  props: {
    edit: false,
    page: 0
  },
  methods: {
    ...mapActions([
      'Product/getProduct',
      'Product/fetchProducts',
      'Supplier/fetchSuppliers',
      'ProductType/fetchProductTypes'
    ]),
    clearCreate() {},
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveProduct() {
      if (1 == 1 || this.$refs.editForm.validate()) {
        const formData = new FormData(this.$refs.editForm.$el);
        formData.append('meta', JSON.stringify(this.editFields.meta));
        formData.append('remaining_files', JSON.stringify(this.editFields.current_files));
        formData.append('supplier_id', this.editFields.supplier_id);
        formData.append('product_type_id', this.editFields.product_type_id);
        formData.append('karat', this.editFields.karat);
        formData.append('gold_classification', this.editFields.gold_classification);
        axios
          .post(`api/v1/product/${this.$route.params.id}/updateProduct`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Product saved...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.editForm.resetValidation();
            this['Product/getProduct']({ id: this.$route.params.id });
            this['Product/fetchProducts']({ page: this.page });
            this.$router.push('/product');
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {});
      }
    },
    removeSpec(index) {
      this.editFields.meta.splice(index, 1);
    },
    removeFile(index) {
      //console.log('asfd');
      this.editFields.current_files.splice(index, 1);
    },
    addSpec(name, value) {
      if (!!name.trim()) {
        this.editFields.meta.push({
          specName: name,
          value: value
        });
        this.addSpecError = undefined;
      } else {
        this.addSpecError = [this.rem('Specification Name')];
      }
    },
    goToShow() {
      this.$router.push(`/product/${this.$route.params.id}`);
    }
  }
};
</script>